import { FC } from "react";
import { Col, Row, Typography } from "antd";

import { CheckCircleFilled, ExclamationCircleOutlined } from "../../../../..";

import styles from "./TaskOverview.module.less";

const { Text } = Typography;

export interface TaskOverviewProps {
  /**
   * Translated titles for each category
   */
  headers: {
    todo: string;
    done: string;
    overdue: string;
  };
  /**
   * number tasks which are still to be addressed
   */
  todo: number;
  /**
   * number of completed tasks
   */
  done: number;
  /**
   * number of overdue tasks
   */
  overdue?: number;
}

/**
 * Game plan list item task overview
 * @param todo
 * @param done
 * @param overdue
 */
const TaskOverview: FC<TaskOverviewProps> = ({ todo, done, overdue, headers }) => {
  return (
    <Row gutter={[0, 4]} justify="space-between">
      <Col span={!overdue ? 12 : 8} md={24}>
        <Row align="middle">
          <Col className={styles.Circle} />
          <Text className={styles.Count}>{todo}</Text>
          <Text type="secondary">{headers.todo}</Text>
        </Row>
      </Col>
      <Col span={!overdue ? 12 : 8} md={24}>
        <Row align="middle">
          <CheckCircleFilled className={styles.Done} />
          <Text className={styles.Count}>{done}</Text>
          <Text type="secondary">{headers.done}</Text>
        </Row>
      </Col>
      {!!overdue && (
        <Col span={8} md={24}>
          <Row align="middle">
            <ExclamationCircleOutlined className={styles.Overdue} />
            <Text className={styles.Count}>{overdue}</Text>
            <Text type="secondary">{headers.overdue}</Text>
          </Row>
        </Col>
      )}
    </Row>
  );
};

export default TaskOverview;
